import { e as i } from "./chunk-base-D76d76ww.js";
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function f(e, c) {
  return (t, o, l) => {
    const n = (u) => {
      var r;
      return ((r = u.renderRoot) == null ? void 0 : r.querySelector(e)) ?? null;
    };
    return i(t, o, { get() {
      return n(this);
    } });
  };
}
export {
  f as e
};
